import { useState } from 'react';

export const useForm = (options) => {
  const [data, setData] = useState(options?.initialValues || {});
  const [errors, setErrors] = useState({});

  const setValues = (values) => {
    setData({
      ...data,
      ...values,
    });
  };

  /**
   * Validate a single value.
   * @returns
   */
  const validate = (validation, value) => {
    if (validation?.required?.value && !value) {
      return {
        result: false,
        errorMessage: validation?.required?.message,
      };
    }

    const pattern = validation?.pattern;
    if (pattern?.value && !RegExp(pattern.value).test(value)) {
      return {
        result: false,
        errorMessage: pattern.message,
      };
    }

    const custom = validation?.custom;
    if (custom?.isValid && !custom.isValid(value)) {
      return {
        result: false,
        errorMessage: custom.message,
      };
    }

    return {
      result: true,
    };
  };

  /**
   * Handle the change of a specific field. This can be used to undo a validation error.
   * @returns
   */
  const handleChange = (key, sanitizeFn) => (e) => {
    const value = sanitizeFn ? sanitizeFn(e.target.value) : e.target.value;

    if (e.target.type === 'checkbox') {
      value = !data[key];
    }

    setData({
      ...data,
      [key]: value,
    });

    if (errors[key]) {
      let valid = true;
      const newErrors = errors;
      const validations = options?.validations;
      const validation = validations[key];

      const { result, errorMessage } = validate(validation, value);
      if (!result) {
        valid = false;
        newErrors[key] = errorMessage;
      } else {
        delete newErrors[key];
      }

      setErrors(newErrors);
    }
  };

  /**
   * Submit a form and validate errors.
   */
  const handleSubmit = async (e) => {
    e.preventDefault();

    const validations = options?.validations;
    if (validations) {
      let valid = true;
      const newErrors = {};

      for (const key in validations) {
        const value = data[key];
        const validation = validations[key];

        const { result, errorMessage } = validate(validation, value);
        if (!result) {
          valid = false;
          newErrors[key] = errorMessage;
        }
      }

      if (!valid) {
        setErrors(newErrors);

        if (options?.onValidationFailed) {
          options.onValidationFailed();
        }

        return;
      }
    }

    setErrors({});

    if (options?.onSubmit) {
      options.onSubmit();
    }
  };

  return {
    data,
    errors,
    setValues,
    handleChange,
    handleSubmit,
  };
};
